import { UserProfile, itinerary } from './Types'
import { User } from '@auth0/auth0-react'
import { isAccommodation, isActivity, isCarRental, isFerry, isFlight, isRestaurant, isTrain, keyExistInObject, Time } from './utilities/function'
import moment from 'moment';
import Helper from '../Helper';

const EmailTemplate = (buliddata: itinerary, Profile: UserProfile, user: User, cart: any, type: any) => {


    var htmlContent = `<!DOCTYPE html
    <html>
    <body
        style="width:100%;font-family:arial, 'helvetica neue', helvetica, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
        <div class="es-wrapper-color" style="background-color:#F6F6F6">
            <!--[if gte mso 9]>
    <v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
    <v:fill type="tile" color="#f6f6f6"></v:fill>
    </v:background>
    <![endif]-->
            <table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0"
                style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top;background-color:#F6F6F6">
                <tr>
                    <td valign="top" style="padding:0;Margin:0">
                        <table class="es-header" cellspacing="0" cellpadding="0" align="center"
                            style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
                            <tr>
                                <td align="center" style="padding:0;Margin:0">
                                    <table class="es-header-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff"
                                        align="center"
                                        style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">
                                        <tr>
                                            <td align="left"
                                                style="Margin:0;padding-bottom:20px;padding-top:40px;padding-left:40px;padding-right:40px">
                                                <table cellspacing="0" cellpadding="0" width="100%"
                                                    style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                    <tr>
                                                        <td class="es-m-p0r" valign="top" align="center"
                                                            style="padding:0;Margin:0;width:520px">
                                                            <table width="100%" cellspacing="0" cellpadding="0"
                                                                role="presentation"
                                                                style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                                <tr>
                                                                    <td align="center"
                                                                        style="padding:0;Margin:0;font-size:0px">
                                                                        <img class="adapt-img" src="https://travelsment-images.s3.amazonaws.com/Travelsment.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="230"></td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                        <table class="es-content" cellspacing="0" cellpadding="0" align="center"
                            style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                            <tr>
                                <td align="center" style="padding:0;Margin:0">
                                    <table class="es-content-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff"
                                        align="center"
                                        style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">
                                        <tr>
                                            <td align="left"
                                                style="padding:0;Margin:0;padding-top:20px;padding-left:20px;padding-right:20px">
                                                <table width="100%" cellspacing="0" cellpadding="0"
                                                    style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                    <tr>
                                                        <td valign="top" align="center"
                                                            style="padding:0;Margin:0;width:560px">
                                                            <table width="100%" cellspacing="0" cellpadding="0"
                                                                role="presentation"
                                                                style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                                <tr>
                                                                    <td align="left" style="padding:0;Margin:0">
                                                                       ${type === 'cart' ? `<p
            style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px">
            ${Object.keys(Profile).length > 0 && keyExistInObject(Profile as UserProfile, 'firstName') ? keyExistInObject(Profile as UserProfile, 'firstName') : buliddata?.travelAnswer?.name ? buliddata?.travelAnswer?.name : user?.nickname} has made Payment for the Itinerary  ${buliddata?.name}
        </p>`: type === 'reserved' ? `<p
            style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px">
            ${Object.keys(Profile).length > 0 && keyExistInObject(Profile as UserProfile, 'firstName') ? keyExistInObject(Profile as UserProfile, 'firstName') : buliddata?.travelAnswer?.name ? buliddata?.travelAnswer?.name : user?.nickname} has reserved an accommodation for the Itinerary  ${buliddata?.name}
        </p>`: type === 'failed' ? `<p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px"> The Payment made by 
             ${Object.keys(Profile).length > 0 && keyExistInObject(Profile as UserProfile, 'firstName') ? keyExistInObject(Profile as UserProfile, 'firstName') : buliddata?.travelAnswer?.name ? buliddata?.travelAnswer?.name : user?.nickname} for the Itinerary ${buliddata?.name} was failed
                                                                        </p>`: `<p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px">
             ${Object.keys(Profile).length > 0 && keyExistInObject(Profile as UserProfile, 'firstName') ? keyExistInObject(Profile as UserProfile, 'firstName') : buliddata?.travelAnswer?.name ? buliddata?.travelAnswer?.name : user?.nickname} has submitted Proposal for the Itinerary ${buliddata?.name} 
                                                                        </p>`}
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                        <table class="es-footer" cellspacing="0" cellpadding="0" align="center"
                            style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
                            <tr>
                                <td align="center" style="padding:0;Margin:0">
                                    <table class="es-footer-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff"
                                        align="center"
                                        style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">
                                        <tr>
                                            <td align="left"
                                                style="Margin:0;padding-top:20px;padding-bottom:20px;padding-left:20px;padding-right:20px">
                                                <table cellspacing="0" cellpadding="0" width="100%"
                                                    style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                    <tr>
                                                        <td align="left" style="padding:0;Margin:0;width:560px">
                                                            <table width="100%" cellspacing="0" cellpadding="0"
                                                                role="presentation"
                                                                style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
                                                                <tr>
                                                                    <td style="padding:0;Margin:0">
                                                                    qwerty
                                                                                                                            </td>
                                                                                                                        </tr>
                                                                                                                    </table>
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        </table>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            </table>
                                                                                        </td>
                                                                                   </tr>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                    </table>
            <style type="text/css">
    a {text-decoration: none;}
    </style>
    <![endif]-->
        <!--[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]-->
        <!--[if gte mso 9]>
    <xml>
    <o:OfficeDocumentSettings>
    <o:AllowPNG></o:AllowPNG>
    <o:PixelsPerInch>96</o:PixelsPerInch>
    </o:OfficeDocumentSettings>
    </xml>
    <![endif]-->
        <style type="text/css">
    .DayHead{
        text-align: left;
        align-items: left;
    }

    .tableWidhth{
        width: 100%;
        border:none;
    }
    h4{
    margin: 0;
    }

    th{
        padding: 8px;
        border-bottom: 1px solid red;

    }
    td{
           padding: 8px 0px;
    }
    tr{
        padding: 8px;
    }
            #outlook a {
                padding: 0;
            }

            .es-button {
                mso-style-priority: 100 !important;
                text-decoration: none !important;
            }

            a[x-apple-data-detectors] {
                color: inherit !important;
                text-decoration: none !important;
                font-size: inherit !important;
                font-family: inherit !important;
                font-weight: inherit !important;
                line-height: inherit !important;
            }

            .es-desk-hidden {
                display: none;
                float: left;
                overflow: hidden;
                width: 0;
                max-height: 0;
                line-height: 0;
                mso-hide: all;
            }

            .es-button-border:hover a.es-button,
            .es-button-border:hover button.es-button {
                background: #56d66b !important;
            }

            .es-button-border:hover {
                border-color: #42d159 #42d159 #42d159 #42d159 !important;
                background: #56d66b !important;
            }

            @media only screen and (max-width:600px) {

                p,
                ul li,
                ol li,
                a {
                    line-height: 150% !important
                }

                h1,
                h2,
                h3,
                h1 a,
                h2 a,
                h3 a {
                    line-height: 120% !important
                }

                h1 {
                    font-size: 30px !important;
                    text-align: left
                }

                h2 {
                    font-size: 24px !important;
                    text-align: left
                }

                h3 {
                    font-size: 20px !important;
                    text-align: left
                }

                .es-header-body h1 a,
                .es-content-body h1 a,
                .es-footer-body h1 a {
                    font-size: 30px !important;
                    text-align: left
                }

                .es-header-body h2 a,
                .es-content-body h2 a,
                .es-footer-body h2 a {
                    font-size: 24px !important;
                    text-align: left
                }

                .es-header-body h3 a,
                .es-content-body h3 a,
                .es-footer-body h3 a {
                    font-size: 20px !important;
                    text-align: left
                }

                .es-menu td a {
                    font-size: 14px !important
                }

                .es-header-body p,
                .es-header-body ul li,
                .es-header-body ol li,
                .es-header-body a {
                    font-size: 14px !important
                }

                .es-content-body p,
                .es-content-body ul li,
                .es-content-body ol li,
                .es-content-body a {
                    font-size: 14px !important
                }

                .es-footer-body p,
                .es-footer-body ul li,
                .es-footer-body ol li,
                .es-footer-body a {
                    font-size: 14px !important
                }

                .es-infoblock p,
                .es-infoblock ul li,
                .es-infoblock ol li,
                .es-infoblock a {
                    font-size: 12px !important
                }

                *[class="gmail-fix"] {
                    display: none !important
                }

                .es-m-txt-c,
                .es-m-txt-c h1,
                .es-m-txt-c h2,
                .es-m-txt-c h3 {
                    text-align: center !important
                }

                .es-m-txt-r,
                .es-m-txt-r h1,
                .es-m-txt-r h2,
                .es-m-txt-r h3 {
                    text-align: right !important
                }

                .es-m-txt-l,
                .es-m-txt-l h1,
                .es-m-txt-l h2,
                .es-m-txt-l h3 {
                    text-align: left !important
                }

                .es-m-txt-r img,
                .es-m-txt-c img,
                .es-m-txt-l img {
                    display: inline !important
                }

                .es-button-border {
                    display: inline-block !important
                }

                a.es-button,
                button.es-button {
                    font-size: 18px !important;
                    display: inline-block !important
                }

                .es-adaptive table,
                .es-left,
                .es-right {
                    width: 100% !important
                }

                .es-content table,
                .es-header table,
                .es-footer table,
                .es-content,
                .es-footer,
                .es-header {
                    width: 100% !important;
                    max-width: 600px !important
                }

                .es-adapt-td {
                    display: block !important;
                    width: 100% !important
                }

                .adapt-img {
                    width: 100% !important;
                    height: auto !important
                }

                .es-m-p0 {
                    padding: 0px !important
                }

                .es-m-p0r {
                    padding-right: 0px !important
                }

                .es-m-p0l {
                    padding-left: 0px !important
                }

                .es-m-p0t {
                    padding-top: 0px !important
                }

                .es-m-p0b {
                    padding-bottom: 0 !important
                }

                .es-m-p20b {
                    padding-bottom: 20px !important
                }

                .es-mobile-hidden,
                .es-hidden {
                    display: none !important
                }

                tr.es-desk-hidden,
                td.es-desk-hidden,
                table.es-desk-hidden {
                    width: auto !important;
                    overflow: visible !important;
                    float: none !important;
                    max-height: inherit !important;
                    line-height: inherit !important
                }

                tr.es-desk-hidden {
                    display: table-row !important
                }

                table.es-desk-hidden {
                    display: table !important
                }

                td.es-desk-menu-hidden {
                    display: table-cell !important
                }

                .es-menu td {
                    width: 1% !important
                }

                table.es-table-not-adapt,
                .esd-block-html table {
                    width: auto !important
                }

                table.es-social {
                    display: inline-block !important
                }

                table.es-social td {
                    display: inline-block !important
                }

                .es-desk-hidden {
                    display: table-row !important;
                    width: auto !important;
                    overflow: visible !important;
                    max-height: inherit !important
                }
            }
        </style>

        </div>
    </body>

    </html>`
    var tr = '';
    buliddata.type === 'Proposal' && type === '' ? buliddata.proposalView && buliddata?.proposalView.forEach((node) => {
        if (node?.value.length > 0 && node?.value?.filter((node) => { return (node.type === "accommodation" || node.type === "flight" || node.type === "transfer" || node.type === "carRental" || node.type === "train" || node.type === "ferry" || node.type === "Restaurant" || node.type === "activity") && node.selected }).length > 0) {
            tr = tr + `<div style="width: 100%;color: #222; ">
        <table style="width: 100%;border: none;">
          <tr style="padding: 8px;">
            <th colspan="2" style="text-align: left;padding: 8px;
            border-bottom: 1px solid #0081ff;">
                Location ${node?.location}
            </th>
          </tr>`
            if (node?.value.filter((n: any) => { return n?.type === 'transfer' && n?.selected }).length > 0) {
                tr = tr + `<tr >
            <td  style="width: 100%;">
                Transfer
            </td>
            ${node?.value.filter((n: any) => { return n?.type === 'transfer' && n?.selected }).map((tran: any) => {
                    return `<td style="width: 100%;"><h4>${tran.transfer.providerName}</h4></td>`
                })}

        </tr>`
            }
            node?.value?.filter((node) => { return node.type === "accommodation" || node.type === "flight" || node.type === "carRental" || node.type === "train" || node.type === "ferry" || node.type === "Restaurant" || node.type === "activity" }).map((n: any) => {
                return n.type === "flight" && n.selected ?
                    tr = tr + `<tr >
                            <td  style="width: 160px;">
                              Flights
                            </td>
                            <td  style="width: 160px;"><h4>${n.flight.airlineName}</h4></td>
                            </tr>` : n.type === "train" && n.selected ? tr = tr + `<tr >
                        <td  style="width: 160px;">
                           Train
                        </td>
                        <td  style="width: 160px;"><h4>${n?.train?.trainCompany}</h4></td>
                    </tr>`: n.type === "ferry" && n.selected ? tr = tr + `<tr >
                    <td  style="width: 160px;">
                      ferry
                    </td>
                    <td  style="width: 160px;"><h4>${n?.ferry?.ferryCompany}</h4></td>
                </tr>`: n.type === "carRental" && n.selected ? tr = tr + `<tr >
                    <td  style="width: 160px;">
                        car Rental
                    </td>
                    <td  style="width: 160px;"><h4>${n?.carRental?.companyName}</h4></td>
                </tr>`: n.type === "accommodation" && n.selected ? tr = tr + ` <tr >
                        <td  style="width: 160px;">
                          Accomodation
                        </td>
                        <td  style="width: 160px;"><h4>${n.accommodation.name}</h4></td>
                       </tr>
                       <tr>
                        <td  style="width: 160px;">
                          Room
                          </td>
                          <td  style="width: 160px;"><h4>${n.roomDetails.forEach((room: any) => {
                        if (room.selected) {
                            return room.roomDetail.name
                        }
                    })}</h4>
                            </td>
                            </tr>
                       `: null
            })
            tr = tr + `</table></div>`
        }
    }) : buliddata.type === 'Actual' && type === '' ? buliddata.days && buliddata?.days.forEach((node, index: number) => {
        if (node.sorted && node?.sorted.length > 0 && node?.sorted?.filter((node: any) => { return (node.type === "accommodation" || node.type === "flight" || node.type === "carRental" || node.type === "train" || node.type === "ferry" || node.type === "Restaurant" || node.type === "activity") && node.selected && node.bookingStatus !== 'InCart' }).length > 0) {
            tr = tr + `<div style="width: 100%;color: #222; ">
<table style="width: 100%;border: none;">
<tr style="padding: 8px;">
<th colspan="2" style="text-align: left;padding: 8px;
border-bottom: 1px solid #0081ff;">
Day ${index + 1}
</th>
</tr>`;
            node?.sorted?.filter((node) => { return (node.type === "accommodation" || node.type === "flight" || node.type === "carRental" || node.type === "train" || node.type === "ferry" || node.type === "Restaurant" || node.type === "activity") && node.selected && 'bookingStatus' in node && node.bookingStatus !== 'InCart' }).map((n) => {
                return n.type === "flight" && n.selected ?
                    tr = tr + `<tr >
<td  style="width: 160px;">
Flights
</td>
<td  style="width: 160px;"><h4>${isFlight(n) && n.flight.airlineName}</h4></td>
</tr>` : n.type === "train" && n.selected ? tr = tr + `<tr >
<td  style="width: 160px;">
Train
</td>
<td  style="width: 160px;"><h4>${isTrain(n) && n?.train?.trainCompany}</h4></td>
</tr>`: n.type === "ferry" && n.selected ? tr = tr + `<tr >
<td  style="width: 160px;">
ferry
</td>
<td  style="width: 160px;"><h4>${isFerry(n) && n?.ferry?.ferryCompany}</h4></td>
</tr>`: n.type === "carRental" && n.selected ? tr = tr + `<tr >
<td  style="width: 160px;">
car Rental
</td>
<td  style="width: 160px;"><h4>${isCarRental(n) && n?.provider}</h4></td>
</tr>`: n.type === "Restaurant" && n.selected ? tr = tr + `<tr >
<td  style="width: 160px;">
Restaurant
</td>
<td  style="width: 160px;"><h4>${isRestaurant(n) && n?.restaurant?.name}</h4></td>
</tr>` : n.type === "activity" && n.selected ? tr = tr + `<tr >
<td  style="width: 160px;">
Activity
</td>
<td  style="width: 160px;"><h4>${isActivity(n) && n?.activity?.name}</h4></td>
</tr>`: n.type === "accommodation" && n.selected ? tr = tr + ` <tr >
<td  style="width: 160px;">
Accomodation
</td>
<td  style="width: 160px;"><h4>${isAccommodation(n) && n.accommodation.name}</h4></td>
</tr>
<tr>
<td  style="width: 160px;">
Room
</td>
<td  style="width: 160px;"><h4>${isAccommodation(n) && n.roomDetails.forEach((room) => {
                        if (room.selected) {
                            return room.roomDetail.name
                        }
                    })}</h4>
</td>
</tr>
`: null
            })
            tr = tr + `</table></div>`
        }
    }) : type === 'cart' ? cart.length > 0 && cart.forEach((n: any, index: number) => {
        if (n.type === 'activity') {
            tr = tr + `<div style="width: 100%;color: #222; ">
<table style="width: 100%;border: none;">`;
            tr = tr + `<tr >
<td  style="width: 160px;">
Activity
</td>
<td  style="width: 160px;"><h4>${n?.activity?.name}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Price
</td>
<td  style="width: 160px;"><h4>${n?.publishedPrice}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Start Date
</td>
<td  style="width: 160px;"><h4>${moment.utc(n?.date).format('dddd, MMMM D, YYYY')} </h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Start Time
</td>
<td  style="width: 160px;"><h4>${Helper.TimeConverter(n?.startTime)}</h4></td>
</tr>`
            tr = tr + `</table></div>`
        }
        else if (n.type === 'insurances') {
            tr = tr + `<div style="width: 100%;color: #222; ">
<table style="width: 100%;border: none;">`;
            tr = tr + `<tr >
<td  style="width: 160px;">
Insurance
</td>
<td  style="width: 160px;"><h4>${n?.insurance?.provider}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Price
</td>
<td  style="width: 160px;"><h4>${n?.publishedPrice}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Plan
</td>
<td  style="width: 160px;"><h4>${n.insurance.plan} </h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
State
</td>
<td  style="width: 160px;"><h4>${n.insurance.state}</h4></td>
</tr>`
            tr = tr + `</table></div>`
        }
        else if (n.type === 'train') {
            tr = tr + `<div style="width: 100%;color: #222; ">
<table style="width: 100%;border: none;">`;
            tr = tr + `<tr >
<td  style="width: 160px;">
Train
</td>
<td  style="width: 160px;"><h4>${n?.train?.trainCompany}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
TRain Number
</td>
<td  style="width: 160px;"><h4>${n?.trainNumber} </h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
DepartureTime
</td>
<td  style="width: 160px;"><h4>${Time(n?.departTime)},${moment.utc(n?.departDate).format('MMM Do YYYY')}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
ArrivalTime
</td>
<td  style="width: 160px;"><h4>${Time(n?.arrivalTime)},${moment.utc(n?.arrivalDate).format('MMM Do YYYY')}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Price
</td>
<td  style="width: 160px;"><h4>${n?.publishedPrice}</h4></td>
</tr>`
            tr = tr + `</table></div>`
        }
        else if (n.type === 'accommodation') {
            tr = tr + `<div style="width: 100%;color: #222; ">
<table style="width: 100%;border: none;">`;
            tr = tr + `<tr >
<td  style="width: 160px;">
Accommodation
</td>
<td  style="width: 160px;"><h4>${n?.accommodation?.name}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Room
</td>
<td  style="width: 160px;"><h4>${n?.roomDetails[0].roomDetail.name} </h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
CheckIn
</td>
<td  style="width: 160px;"><h4>${Time(n?.checkInTime)},${moment.utc(n?.checkInDate).format('MMM Do YYYY')}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
CheckOut
</td>
<td  style="width: 160px;"><h4>${Time(n?.checkOutTime)},${moment.utc(n?.checkOutDate).format('MMM Do YYYY')}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Price
</td>
<td  style="width: 160px;"><h4>${n?.publishedPrice}</h4></td>
</tr>`
            tr = tr + `</table></div>`
        }
        else if (n.type === 'carRental') {
            tr = tr + `<div style="width: 100%;color: #222; ">
<table style="width: 100%;border: none;">`;
            tr = tr + `<tr >
<td  style="width: 160px;">
Car Rental
</td>
<td  style="width: 160px;"><h4>${n?.carRental?.companyName}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Car Brand
</td>
<td  style="width: 160px;"><h4>${n?.carBrand} </h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Pick up 
</td>
<td  style="width: 160px;"><h4>${n?.pickUpLocation} ,${moment.utc(n?.pickUpDate).format('dddd, MMMM D')} ,${Time(n?.pickUpTime)}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Drop off
</td>
<td  style="width: 160px;"><h4>${n?.dropOffLocation}, ${moment.utc(n?.dropOffDate).format('dddd, MMMM D')} ,${Time(n?.dropOffTime)}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Price
</td>
<td  style="width: 160px;"><h4>${n?.publishedPrice}</h4></td>
</tr>`
            tr = tr + `</table></div>`
        }
        else if (n.type === 'ferry') {
            tr = tr + `<div style="width: 100%;color: #222; ">
<table style="width: 100%;border: none;">`;
            tr = tr + `<tr >
<td  style="width: 160px;">
Ferry
</td>
<td  style="width: 160px;"><h4>${n?.ferry?.ferryCompany}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Confirmation Number
</td>
<td  style="width: 160px;"><h4>${n?.confirmationNumber} </h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Depart
</td>
<td  style="width: 160px;"><h4>${n?.ferry?.departurePort} ,${moment.utc(n?.departDate).format('dddd, MMMM D')} ,${Time(n?.departTime)}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Arrival
</td>
<td  style="width: 160px;"><h4>${n?.ferry?.arrivalPort}, ${moment.utc(n?.arrivalDate).format('dddd, MMMM D')} ,${Time(n?.arrivalTime)}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Price
</td>
<td  style="width: 160px;"><h4>${n?.publishedPrice}</h4></td>
</tr>`
            tr = tr + `</table></div>`
        }
        else if (n.type === 'transfer') {
            tr = tr + `<div style="width: 100%;color: #222; ">
<table style="width: 100%;border: none;">`;
            tr = tr + `<tr >
<td  style="width: 160px;">
Transfer
</td>
<td  style="width: 160px;"><h4>${n?.transfer?.providerName}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Transfer Type
</td>
<td  style="width: 160px;"><h4>${n?.transferType} </h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Pick up Time
</td>
<td  style="width: 160px;"><h4>${moment.utc(n?.transferDate).format('dddd, MMMM D')} ,${Time(n?.startTime)}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Price
</td>
<td  style="width: 160px;"><h4>${n?.publishedPrice}</h4></td>
</tr>`
            tr = tr + `</table></div>`
        }
        else if (n.__typename === 'ItineraryFlight') {
            tr = tr + `<div style="width: 100%;color: #222;">
<table style="width: 100%;border: none;">`;
            tr = tr + `<tr >
<td  style="width: 160px;">
Flight
</td>
<td  style="width: 160px;"><h4>${n?.flight?.airlineName}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
flight Number
</td>
<td  style="width: 160px;"><h4>${n?.flight?.flgithNumber} </h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
DepartureTime
</td>
<td  style="width: 160px;"><h4>${Time(n?.departTime)},${moment.utc(n?.departDate).format('MMM Do YYYY')}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
ArrivalTime
</td>
<td  style="width: 160px;"><h4>${Time(n?.arrivalTime)},${moment.utc(n?.arrivalDate).format('MMM Do YYYY')}</h4></td>
</tr>`
            tr = tr + `<tr >
<td  style="width: 160px;">
Price
</td>
<td  style="width: 160px;"><h4>${n?.publishedPrice}</h4></td>
</tr>`
            tr = tr + `</table></div>`
        }
    }) : tr = ''
    htmlContent = htmlContent.replace('qwerty', tr)

    return htmlContent

}

export default EmailTemplate